import * as React from 'react'
import IconPanel, { IconProps } from '@mulesoft/anypoint-icons/lib/Icon'
import './AnnouncementBanner.css'

export type Props = {
    icon?: IconProps
    linkMessage?: string
    onLinkClick?: () => void
    basicMessage?: string
    type?: 'info' | 'warning' | 'error'
    children?: React.ReactNode
}

const AnnouncementBanner = ({icon, linkMessage, onLinkClick, basicMessage, type = 'info', children}: Props) => {
    const bannerClass = `mdas-announcement-banner mdas-announcement-banner--${type}`
    
    return (
        <div className={bannerClass}>
            {icon && <IconPanel className="mdas-announcement-banner-icon" {...icon}/>}

            {linkMessage && onLinkClick && <button id="mdas-announcement-banner-button" onClick={onLinkClick}>{linkMessage}</button>}

            {basicMessage && <label id="mdas-announcement-banner-label">{basicMessage}</label>}

            {children}
        </div>
    )
}

export default AnnouncementBanner
